/* eslint-disable react/no-array-index-key */
import { ZorgkostenDeclarerenGemoedsbezwaardenPage } from "@page/forms-zorgkosten-declareren-gemoedsbezwaarden-formulier";
import { KlachtenFormulierZvwPage } from "@page/klachtenformulier-zvw";
import { OnderhoudPage } from "@page/onderhoud";
import { StopzettenBroninhoudingPage } from "@page/stopzetten-broninhouding-formulier";
import { Language, setCurrentLanguage } from "@shared/locales";
import axios from "axios";
import { PiletApi } from "opencak-app";
import * as React from "react";
import { interceptors } from "./interceptors/Interceptors";

export function setup(app: PiletApi) {
  const basePath = app.getData("base-path");
  const apiUrl = app.getData("api-path");
  const authEnabled = app.getData("api-auth-enabled");

  axios.defaults.withCredentials = authEnabled;

  const Layout = app.getFormPageLayoutComponent();

  const allFeatures = app.allFeaturesToggle();
  const onderhoudEnabled = allFeatures.find((feature) => feature.name === "formulieren/onderhoud")?.enabled;

  const lang = app.getLanguage();
  const onderhoudPagePath =
    lang === Language.Nederlands ? `${basePath}/onderhoud` : `${basePath}/maintenance`;

  if (onderhoudEnabled) {
    const onderhoudPage = () => <OnderhoudPage language={lang} />;
    app.registerPage(onderhoudPagePath, onderhoudPage);

    if (window.location.pathname !== onderhoudPagePath) {
      window.location.assign(onderhoudPagePath);
    }
    return;
  }

  const onderhoudPagePathRegex = new RegExp(`^${onderhoudPagePath}/?$`);
  const isOnderhoudPage = onderhoudPagePathRegex.test(window.location.pathname);
  if (isOnderhoudPage) {
    window.location.assign("/");
    return;
  }

  const KlachtenFormulierZvwForm = (curentLanguage: string) => () => {
    React.useEffect(() => {
      interceptors.initialize(axios, curentLanguage);
    }, []);
    return (
      <Layout>
        <div className="formulier-page-container formulier-page-container--zvw">
          <KlachtenFormulierZvwPage
            pageBaseUrl={
              curentLanguage === "nl"
                ? `${basePath}/zelf-regelen/klachtenformulier-zvw`
                : `${basePath}/self-service/complaint-form-zvw/en`
            }
            apiUrl={apiUrl}
            language={curentLanguage}
          />
        </div>
      </Layout>
    );
  };

  app.registerPage(
    `${basePath}/zelf-regelen/klachtenformulier-zvw/:formStep?`,
    KlachtenFormulierZvwForm("nl")
  );
  app.registerPage(
    `${basePath}/self-service/complaint-form-zvw/en/:formStep?`,
    KlachtenFormulierZvwForm("en")
  );

  const zorgkostenDeclarerenGemoedsbezwaardenNlPath = "/zelf-regelen/zorgkosten-declareren";

  const ZorgkostenDeclarerenGemoedsbezwaardenForm = (currentLanguage: string) => () => {
    React.useEffect(() => {
      interceptors.initialize(axios, currentLanguage);
    }, []);

    setCurrentLanguage(Language.Nederlands);
    return (
      <Layout>
        <div className="formulier-page-container-stepper-form">
          <ZorgkostenDeclarerenGemoedsbezwaardenPage
            pageBaseUrl={zorgkostenDeclarerenGemoedsbezwaardenNlPath}
            basePath={basePath}
            apiUrl={apiUrl}
            language={Language.Nederlands}
          />
        </div>
      </Layout>
    );
  };

  app.registerPage(
    `${basePath}${zorgkostenDeclarerenGemoedsbezwaardenNlPath}/:formStep?`,
    ZorgkostenDeclarerenGemoedsbezwaardenForm("nl")
  );

  const stopzettenBroninhoudingNlPath = "/zelf-regelen/stopzetten-broninhouding";

  const StopzettenBroninhoudingForm = (currentLanguage: string) => () => {
    React.useEffect(() => {
      interceptors.initialize(axios, currentLanguage);
    }, []);

    setCurrentLanguage(Language.Nederlands);
    return (
      <Layout>
        <div className="formulier-page-container-stepper-form">
          <StopzettenBroninhoudingPage
            pageBaseUrl={stopzettenBroninhoudingNlPath}
            basePath={basePath}
            apiUrl={apiUrl}
            language={Language.Nederlands}
          />
        </div>
      </Layout>
    );
  };

  app.registerPage(
    `${basePath}${stopzettenBroninhoudingNlPath}/:formStep?`,
    StopzettenBroninhoudingForm("nl")
  );
}
